export default __webpack_public_path__ + "static/media/fiat.8fe33cc1.svg";